module.exports = __webpack_public_path__ + "img/Smartfolio-logo.993626d0.jpg";